import script from "./FavoritosView.vue?vue&type=script&setup=true&lang=js"
export * from "./FavoritosView.vue?vue&type=script&setup=true&lang=js"

import "./FavoritosView.vue?vue&type=style&index=0&id=a530e1da&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a530e1da"]])

export default __exports__